import { Chatbot } from 'actions';

const initialState = {
  messages: [],
  previous_response_id: '',
  isFetching: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Chatbot.SEND_MESSAGE:
      return {
        ...state,
        isFetching: true,
        messages: [
          ...state.messages,
          {
            type: 'sent',
            role: 'user',
            content: action.question,
          },
        ],
      };

    case Chatbot.RECEIVE_ANSWER:
      return {
        ...state,
        isFetching: false,
        messages: [
          ...state.messages,
          {
            type: 'received',
            role: 'assistant',
            content: action.answer,
          },
        ],
      };

    case Chatbot.SET_PREVIOUS_RESPONSE_ID:
      return {
        ...state,
        previous_response_id: action.previous_response_id,
      };

    case Chatbot.CLEAR:
      return {
        ...state,
        messages: [],
        previous_response_id: '',
      };

    default:
      return state;
  }
}
